import { css } from '@microsoft/fast-element';
import { gridButtonStyling } from '../../../styles';

export const ProjectVppaCardStyles = css`
  ${gridButtonStyling}
  .project-card {
    padding: 10px 12px;
    border-bottom: 1px solid var(--border-1);
    background-color: rgb(135 155 166 / 0%);
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }

  .project-card:hover {
    background-color: rgb(45 47 51 / 100%);
  }

  .project-card-selected {
    background-color: var(--blue-darker);
  }

  .project-card-selected:hover {
    background-color: var(--blue-darker);
  }

  .content {
    border-radius: 6px;
    box-sizing: border-box;
  }

  .project-header-container {
    display: flex;
    gap: 3px;
  }

  .project-name {
    color: var(--primary-color);
    margin: 0;
    font-size: 13px;
    float: left;
  }

  .project-name:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  .project-legal-name {
    color: var(--gray-lighter);
    margin: 0;
    font-size: 10px;
    font-weight: 500;
    min-height: 21px;
    min-width: 170px;
  }

  .button-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .chevron-control-button {
    width: 31px;
    height: 22px;
    border-radius: 2px;
    background-color: rgb(135 155 166 / 10%);
  }

  .chevron-control-button::part(control) {
    padding: 2px;
  }

  .chevron-control-button::part(end) {
    transition: all 0.5s ease;
  }

  .chevron-control-button svg {
    width: auto;
    height: auto;
  }

  .rotate-icon::part(end) {
    transform: rotate(90deg);
    transition: all 0.5s ease;
  }

  .vppa-grid {
    height: 100px;
  }

  .grid-styles {
    width: 100%;
    height: 100%;
  }

  .icon {
    padding-right: 12px;
    display: flex;
    align-items: center;
  }

  zero-grid-pro::part(actionWrapper) {
    justify-content: unset;
  }

  zero-grid-pro::part(gridIconButton) {
    background-color: transparent;
  }

  zero-grid-pro::part(leftButtons) {
    display: none;
  }

  zero-grid-pro::part(hyperlinkStatic) {
    text-decoration: unset;
  }

  zero-grid-pro::part(hyperlinkStatic):hover {
    text-decoration: underline;
  }
`;
